export const generateChatId = ({ id, type }: { id: number; type: 'user' | 'admin' }) => `${id}-${type}`;
